import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { CadsIconViewBitComponent } from '../../bits/cads-icon-view-bit/cads-icon-view-bit.component';
import { cadsIconTileButtonInteractionVars } from '../../utils/cads-semantic-color.util';

import type { CadsIconTileButtonConfig } from './cads-icon-tile-button.config';

/**
 * Dashboard **quick action**: circular icon tile with caption below. Host handles navigation on {@link tapped}.
 */
@Component({
  selector: 'cads-icon-tile-button',
  imports: [NgStyle, CadsIconViewBitComponent],
  templateUrl: './cads-icon-tile-button.component.html',
  styleUrl: './cads-icon-tile-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'cads-icon-tile-button-host',
  },
})
export class CadsIconTileButtonComponent {
  readonly config = input.required<CadsIconTileButtonConfig>();

  readonly tapped = output<void>();

  protected readonly _iconConfig = computed(() => ({
    ...this.config().icon,
    shape: 'circle' as const,
    size: this.config().icon.size ?? ('medium' as const),
    color: this.config().icon.color ?? 'var(--cads-color-mid-gray)',
  }));

  /** Semantic ramp vars for hover/active on the circular tile (from {@link CadsIconTileButtonConfig.icon}.color). */
  protected readonly _interactionVars = computed(() =>
    cadsIconTileButtonInteractionVars(this.config().icon.color)
  );

  protected _onActivate(): void {
    if (this.config().disabled) {
      return;
    }
    this.tapped.emit();
  }
}
